import {
  BonusesWeek,
  WithdrawWttBonuses,
  WithdrawWttBonusesInfo,
} from "@/modules/user/types/bonuses";
import { apiWithAuth } from "../authApi";

export const getBonusesWeek = async (
  weekOffset?: number
): Promise<BonusesWeek | undefined> => {
  try {
    const response = await apiWithAuth.get("/user/wtt/bonuses/week", {
      params: weekOffset !== undefined ? { weekOffset } : {},
    });

    const answer = response.data as BonusesWeek;

    return answer;
  } catch (error) {
    return undefined;
  }
};

export const getWithdrawWttBonusesInfo = async (): Promise<
  WithdrawWttBonusesInfo | undefined
> => {
  try {
    const response = await apiWithAuth.get("/user/withdraw/wtt/bonuses");

    const answer = response.data as WithdrawWttBonusesInfo;

    return answer;
  } catch (error) {
    return undefined;
  }
};

export const postWithdrawWttBonuses = async (): Promise<
  WithdrawWttBonuses | undefined
> => {
  try {
    const response = await apiWithAuth.post("/user/withdraw/wtt/bonuses");

    const answer = response.data as WithdrawWttBonuses;

    return answer;
  } catch (error) {
    return undefined;
  }
};
